import { PORTAL_TOKEN_KEY } from "../../portal/portalAxios";
import { LiveKind, MessagesHubClient } from "./messagesHubClient";

const clients = new Map<LiveKind, MessagesHubClient>();

let staffToken: () => string | null | undefined = () => null;

/** Called once by the store: the instructor token, the one the axios instance sends. */
export const injectMessagesHubTokenSource = (source: () => string | null | undefined): void => {
  staffToken = source;
};

/** Where each kind's token comes from: the same sources the two axios instances read. */
const tokenSources: Record<LiveKind, () => string | null | undefined> = {
  staff: () => staffToken(),
  portal: () => localStorage.getItem(PORTAL_TOKEN_KEY),
};

/** The app's one connection for the kind, created on first use. */
export const getMessagesHubClient = (kind: LiveKind): MessagesHubClient => {
  let client = clients.get(kind);
  if (!client) {
    client = new MessagesHubClient(tokenSources[kind]);
    clients.set(kind, client);
  }
  return client;
};

/** Tests only: put a client with a fake connection in place. */
export const setMessagesHubClientForTests = (kind: LiveKind, client: MessagesHubClient | null): void => {
  if (client) clients.set(kind, client);
  else clients.delete(kind);
};
